<template>
  <div class="page">
    <accordion :multiple="true" :activeIndex="[0]">
      <accordion-tab>
        <template #header>
          <span>Genera Fatture Energia</span>
        </template>

        <div class="formgrid grid">

          <div class="field col-12">
            <label for="data_inizio">Data Emissione</label>
            <calendar id="data_inizio" class="inputfield w-full" v-model="dataEmissione" :showIcon="true"
              dateFormat="dd/mm/yy" />
          </div>

          <div class="field col-12">
            <label for="mensilita_da_fatturare">Mensilità da fatturare</label>&nbsp;
            <multi-select id="mensilita_da_fatturare" class="inputfield w-full"
              v-model="data.item.mensilita_da_fatturare" :options="data.listaMensilita" optionLabel="label"
              optionValue="value" placeholder="Seleziona mensilità da fatturare" display="chip" />
          </div>

          <div class="field col-12">
            <label for="simula_mese_attuale">Simula mese attuale</label>
            <div>
              <checkbox id="simula_mese_attuale" class="inputfield w-full" v-model="data.item.simula_mese_attuale"
                :binary="true" />
            </div>
          </div>

          <div class="field col-12">
            <label for="clienti_da_eliminare">Clienti da eliminare</label>&nbsp;
            <multi-select id="clienti_da_eliminare" class="inputfield w-full" v-model="data.item.clienti_da_eliminare"
              :options="data.listaClienti" optionLabel="name" optionValue="id"
              placeholder="Seleziona clienti da eliminare" display="chip" />
          </div>

          <div class="field col-12">
            <label for="metodo_pagamento">Metodo pagamento</label>&nbsp;
            <dropdown id="metodo_pagamento" class="inputfield w-full" v-model="data.item.metodo_pagamento"
              :options="data.listaMetodiPagamento" optionLabel="name" optionValue="id"
              placeholder="Seleziona metodo di pagamento" />
          </div>

          <div class="field col-12">
            <label for="metodo_pagamento_da_escludere">Metodo pagamento da escludere</label>&nbsp;
            <dropdown id="metodo_pagamento_da_escludere" class="inputfield w-full"
              v-model="data.item.metodo_pagamento_da_escludere" :options="data.listaMetodiPagamentoDaEscludere"
              optionLabel="name" optionValue="id" placeholder="Seleziona metodo di pagamento" />
          </div>

          <div class="field col-12">
            <label for="elimina_stima">Non stimare mensilità già stimate</label>
            <div>
              <checkbox id="elimina_stima" class="inputfield w-full" v-model="data.item.elimina_stima" :binary="true" />
            </div>
          </div>

          <div class="field col-12">
            <label for="pods">POD da fatturare</label>
            <div>
              <prime-textarea id="pods" class="inputfield w-full" v-model="data.item.pods" :autoResize="true"
                rows="5" />
            </div>
          </div>

          <div class="p-field p-col-12">
            <label for="stress">Stress</label>
            <input-number id="stress" class="inputfield w-full" v-model="data.item.stress" mode="decimal" :min="1"
              :max="100" showButtons />
          </div>

        </div>

        <div class="button-container">
          <prime-button label="Simula" class="mr-2" @click="onMakeSimulation($event)" />
          <prime-button label="Genera Fatture" @click="onMakeInvoices($event)" />
        </div>

      </accordion-tab>
    </accordion>

  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-genera/fatture-service'
import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'
import PrimeTextarea from 'primevue/textarea';

export default {
  components: {
    PrimeButton,
    PrimeTextarea
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      data: {
        item: {
          type: 'POD',
          pods: '',
          pdrs: '',
          stress: 1,
          data_emissione: null,
          simula_mese_attuale: false,
          elimina_stima: true,
          metodo_pagamento: -1,
          metodo_pagamento_da_escludere: -1,

          mensilita_da_fatturare: [],
          clienti_da_eliminare: [],
        },

        listaMensilita: [],
        listaClienti: [],
        listaMetodiPagamento: [],
        listaMetodiPagamentoDaEscludere: [],
      }
    }
  },

  created() {
    this.service = new Service(this.$http, this.$eventBus)
    this.getMesiDaFatturare()

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getListaClienti()
    this.getTipiMetodoPagamentoCliente()
  },

  mounted() {

  },

  methods: {
    getMesiDaFatturare() {
      this.service.getMesiDaFatturare()
        .then((res) => {
          this.data.listaMensilita = res.items.map((el) => {
            return {
              value: el,
              label: moment(el).format('MM/YYYY')
            }
          })
        })
    },

    getListaClienti() {
      this.utilityService.getListaClienti()
        .then((res) => {
          this.data.listaClienti = res.items
        })
    },

    getTipiMetodoPagamentoCliente() {
      this.utilityService.getTipiMetodoPagamentoCliente()
        .then((res) => {
          const clone = [...res.items]
          clone.unshift({
            id: -1,
            name: 'Nessuno'
          })
          this.data.listaMetodiPagamentoDaEscludere = clone

          res.items.unshift({
            id: 999999,
            name: 'Tutti'
          })
          res.items.unshift({
            id: -1,
            name: 'Nessuno'
          })
          this.data.listaMetodiPagamento = res.items
        })
    },

    //// EVENT ////

    onMakeSimulation(/** event **/) {
      const config = JSON.parse(JSON.stringify(this.data.item))
      this.service.makeSimulation(config)
        .then((res) => {
          console.log(res)
        })
    },

    onMakeInvoices(/** event **/) {
      const config = JSON.parse(JSON.stringify(this.data.item))
      this.service.makeInvoices(config)
        .then((res) => {
          console.log(res)
        })
    },
  },

  computed: {
    dataEmissione: {
      get: function () {
        return (this.data.item.data_emissione !== null && this.data.item.data_emissione !== '') ? moment(this.data.item.data_emissione).toDate() : null
      },
      set: function (value) {
        if (value instanceof Date && !isNaN(value.valueOf())) {
          this.data.item.data_emissione = moment(value).format('YYYY-MM-DD')
        }

        if ((value === null) || (value === '')) {
          this.data.item.data_emissione = null
        }
      }
    },
  },
}
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
</style>
